/**
 * Implementation of TailwindToaster custom renderer using react-hot-toast
 * 
 * @author - Harsh Tomar
 */

// Dependencies
import { Transition } from '@headlessui/react';
import { Toaster, ToastType } from 'react-hot-toast';
import { AiFillCheckCircle } from 'react-icons/ai';
import { MdDangerous } from 'react-icons/md';

export default function TailwindToaster() {

  const getBgColor = (type: ToastType) => {
    switch(type) {
      case "success":
        return "bg-green-500";
      case "error":
        return "bg-rose-500";
      case "loading":
        return ""
      default:
        return ""
    }
  }

  const getTextColor = (type: ToastType) => {
    switch(type) {
      case "success":
        return "text-green-500";
      case "error":
        return "text-rose-500";
      case "loading":
        return ""
      default:
        return ""
    }
  }

  const getIcon = (type: string) => {
    switch(type) {
      case "success":
        return <div className={`flex-1 flex justify-center items-center ${getTextColor(type)}`}>
            <AiFillCheckCircle size={24} />
          </div>
      case "error":
        return <div className={`flex-1 flex justify-center items-center ${getTextColor(type)}`}>
            <MdDangerous size={24} />
          </div>
    }
  }
  
  return (
    <Toaster position='top-right' toastOptions={{ duration: 5000 }} containerClassName="mt-16">
      {(t) => (
        <Transition show={t.visible} appear
        enter="transition transform opacity duration-500"
        enterFrom="translate-x-full opacity-0"
        enterTo="translate-x-0 opacity-100"
        leave="transition transform duration-500"
        leaveFrom="translate-x-0 opacity-100"
        leaveTo="translate-x-full opacity-0"
        >
        <div className={`w-96 shadow-xl rounded-xl right-10 flex relative overflow-hidden bg-white`}>
          <div className={`h-[2px] absolute rounded-xl animate-progress ${getBgColor(t.type)}`}></div>
          <div className="px-4 flex">
            {getIcon(t.type)}
          </div>
          <div className="flex-1">
            <p className={`font-bold capitalize mt-2 ${getTextColor(t.type)}`}>{t.type}</p>
            <p className="mb-2 text-gray-700">{t.message}</p>
          </div>
        </div>
      </Transition>
      )}
    </Toaster>
  )
}